var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHr3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1 7.08334C35.7683 6.792 35.3346 6.64417 34.894 6.67229C34.4534 6.70041 34.042 6.90219 33.75 7.23334L30.6333 10.8167L29.5833 9.63334C29.2894 9.30182 28.8758 9.10064 28.4335 9.07408C27.9912 9.04751 27.5565 9.19772 27.225 9.49167C26.8935 9.78562 26.6923 10.1992 26.6657 10.6415C26.6392 11.0838 26.7894 11.5185 27.0833 11.85L29.4 14.45C29.5577 14.6248 29.7506 14.7641 29.9661 14.8589C30.1815 14.9537 30.4146 15.0018 30.65 15C30.8838 14.9974 31.1145 14.9455 31.327 14.8479C31.5394 14.7503 31.729 14.609 31.8833 14.4333L36.2333 9.43334C36.5267 9.10376 36.6774 8.6713 36.6524 8.23078C36.6274 7.79025 36.4288 7.37761 36.1 7.08334ZM16.6667 18.3333C17.9852 18.3333 19.2741 17.9423 20.3705 17.2098C21.4668 16.4773 22.3213 15.4361 22.8259 14.2179C23.3304 12.9997 23.4625 11.6593 23.2052 10.3661C22.948 9.07286 22.3131 7.88497 21.3807 6.95262C20.4484 6.02027 19.2605 5.38534 17.9673 5.1281C16.6741 4.87087 15.3336 5.00289 14.1154 5.50747C12.8973 6.01206 11.8561 6.86654 11.1235 7.96287C10.391 9.0592 10 10.3481 10 11.6667C10 13.4348 10.7024 15.1305 11.9526 16.3807C13.2029 17.631 14.8986 18.3333 16.6667 18.3333ZM26.6667 35C27.1087 35 27.5326 34.8244 27.8452 34.5119C28.1577 34.1993 28.3333 33.7754 28.3333 33.3333C28.3333 30.2391 27.1042 27.2717 24.9162 25.0838C22.7283 22.8958 19.7609 21.6667 16.6667 21.6667C13.5725 21.6667 10.605 22.8958 8.41709 25.0838C6.22916 27.2717 5 30.2391 5 33.3333C5 33.7754 5.17559 34.1993 5.48816 34.5119C5.80072 34.8244 6.22464 35 6.66667 35",
    fill: "url(#paint0_linear_1714_4820)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1714_4820",
    x1: 5,
    y1: 1.25,
    x2: 36.7807,
    y2: 37.9796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EB5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr3);
export default __webpack_public_path__ + "static/media/Hr3.15090ba96f3eec983566d4ad7e00ec85.svg";
export { ForwardRef as ReactComponent };